import { isEmpty } from 'lodash-es';
import { getFilterMetadata } from '../../../components/StatelessComponent/FilterChainUtils';
import type { BasicListOption } from '../../../components/StatelessComponent/SingleFilter/GenericBloc/GenericLargeListFilter/GenericLargeListType';
import {
  OCCURRED_OPTION_LIST,
  SUB_FILTER_KIND_OPTION_LIST,
} from '../../../components/StatelessComponent/SingleFilter/ClickedFilter/subfilter/ClickedFilterConstant';
import type {
  ClickedSubFilter,
  ClickedType,
} from '../../../components/StatelessComponent/SingleFilter/ClickedFilter/ClickedFilterType';
import { FilterKindEnum } from '../../../domains/global-filters/model/FilterChain';
import type { LabelProps } from '../LabelFormatterType';
import { getValueLabel as radioTextGetValueLabel } from './GenericLabelFormatter/RadioTextLabelFormatter';

function getSubFilterLabels(currentValue?: ClickedSubFilter): string {
  const kindLabel = SUB_FILTER_KIND_OPTION_LIST.find(
    (item) => item.value === currentValue?.kind,
  )?.label;
  const radioTextLabel = radioTextGetValueLabel(currentValue?.value);
  return `${kindLabel} ${radioTextLabel}`;
}

const getValueLabel = <T>(currentValue: T, listOption: BasicListOption<T>[]): string => {
  return currentValue == null
    ? ''
    : listOption.find((item) => item.value === currentValue)?.label ?? '';
};

export function getLabels(currentValue?: ClickedType): LabelProps {
  const metadata = getFilterMetadata(FilterKindEnum.Clicked);

  const operationLabel = getValueLabel(currentValue?.operation, OCCURRED_OPTION_LIST);
  const subFilterLabels =
    currentValue && !isEmpty(currentValue.subFilters)
      ? ` where ${currentValue.subFilters.map((item) => getSubFilterLabels(item)).join(' and ')}`
      : '';

  return {
    label1: metadata.filterName,
    label2: `${operationLabel}${subFilterLabels}`,
  };
}
